// extracted by mini-css-extract-plugin
export default {"list":"ConversationList_list__FDzJe","loading":"ConversationList_loading__2JtiL","empty":"ConversationList_empty__6Tv2W"};